<template>
<div class="container">
    <div class="row">
        <div class="col-12">
            <div class="section-heading white text-center mx-auto">
                <!-- <img src="img/core-img/cross.png" alt=""> -->
                <h3>La Obra Misionera</h3>
                <p>
                    Iglesia La Senda Antigua extiende su mano a diferentes obras misioneras en diferentes partes del mundo.
                </p>
            </div>
        </div>
    </div>

    <div class="row">
        <!-- mobile -->
        <div class="col-12  d-block d-sm-none">

            <carousel :items="1" class="donate-slides">
                <div class="single-donate-slide" v-for="mission in missions" :key="mission.index">
                    <img :src="mission.picture" alt="">
                  
                    <div class="donate-content">
                        <h4>{{mission.title}}</h4>
                        <p style="margin-left:10px; margin-right:10px">{{mission.description}}</p>
                    </div>
                  
                    <div class="donate-btn text-center">
                        <router-link class="btn faith-btn active" :to="'missions/'+mission.id">saber más</router-link>                        
                    </div>
                </div>
            </carousel>
        </div>

        <!-- md -->
        <div class="col-md-2 d-none d-sm-block"></div>
        <div class="col-md-4 d-none d-sm-block  " v-for="mission in missions" :key="mission.index">
            <div class="single-donate-slide" @click="$router.push('missions/'+mission.id)" style="cursor:pointer">
                <img :src="mission.picture" alt="">
                <!-- Donate Content -->
                <div class="donate-content">
                    <h4>{{mission.title}}</h4>
                    <p style="margin-left:10px; margin-right:10px">{{mission.description}}</p>
                </div>
                <!-- Donate Button -->
                <div class="donate-btn text-center">
                    <router-link class="btn faith-btn active" :to="'missions/'+mission.id">saber más</router-link>                        
                </div>
            </div>
        </div>        
    </div>

    <!-- <external-scripts/> -->
</div>
</template>

<script>
import carousel from "vue-owl-carousel";

export default {
  components: { carousel },
  mounted() {
    document.getElementsByClassName("owl-next").forEach((element) => {
      element.textContent = ">";
    });
    document.getElementsByClassName("owl-prev").forEach((next) => {
      next.textContent = "<";
    });
  },
  data() {
    return {
      missions: [
        {
          id: 1,
          title: "Tailandia",
          description:
            "cuidado de un orfanatorio de niños birmanos, de las tribus Ahka y Lahu.",
          picture: "img/bg-img/thailand.jpg",
        },
        {
          id: 2,
          title: "Guatemala",
          description: "Alimentos, ropa y educación para niños",
          picture: "img/bg-img/donate2.jpg",
        },
      ],
    };
  },
};
</script>

<style>
</style>